import _ from "lodash";

import { DEFAULT_DURATION } from "@static/DEFAULT_DURATION";

export const onHandleDurationChange = ({
  event,
  setDuration = () => undefined,
}) => {
  const value = _.chain(event).get(["target", "value"]).toInteger().value();
  setDuration(value);
};

export const onHandleDurationBlur = ({
  event,
  setDuration = () => undefined,
  onHandleChangeValue = () => undefined,
}) => {
  const value = _.chain(event).get(["target", "value"]).toInteger().value();
  if (value <= 0 || _.isNaN(value)) {
    setDuration(DEFAULT_DURATION);
    onHandleChangeValue({ key: "duration", value: DEFAULT_DURATION });
  } else {
    onHandleChangeValue({ key: "duration", value });
  }
};
